import { render } from "./CommonErrorComponent.vue?vue&type=template&id=4b902c90"
import script from "./CommonErrorComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CommonErrorComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./CommonErrorComponent.vue?vue&type=style&index=0&id=4b902c90&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__